// src/components/ErrorBoundary.js
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(`[ErrorBoundary${this.props.label ? `:${this.props.label}` : ''}]`, error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback(this.handleRetry);

    const { variant = 'panel', message = 'Something went wrong.' } = this.props;

    return (
      <div className={`lp-error-boundary lp-error-boundary--${variant}`}>
        <div className="lp-error-boundary-title">{message}</div>
        <p className="lp-error-boundary-subtitle">
          This part of Elpis hit a snag. The rest of the app is still working.
        </p>
        <button className="lp-error-boundary-retry" onClick={this.handleRetry}>
          Try again
        </button>
      </div>
    );
  }
}
